
        <div class="buttons">
                <div class="buttonsFillters">
                        <button class="filters" mat-button [ngClass]="(filterMode === 'all') ? 'mat-flat-button':'mat-stroked-button'" color="primary" onclick="this.blur()" (click)="filterCycles('all')">
                                All
                        </button>
                        <button class="filters" mat-button [ngClass]="(filterMode === 'active') ? 'mat-flat-button':'mat-stroked-button'" color="primary" onclick="this.blur()" (click)="filterCycles('active')">
                                Active
                        </button>
                        <button class="filters" mat-button [ngClass]="(filterMode === 'inactive') ? 'mat-flat-button':'mat-stroked-button'" color="primary" onclick="this.blur()" (click)="filterCycles('inactive')">
                                InActive
                        </button>
                </div>
                <div class="buttonsActions" readOnly>
                        <button class="addCycle"
                        mat-flat-button color="primary" style="margin-right: 10px;" (click)="DefaultCycleSettings()"
                        >Default Cycle Settings</button>
                        <button class="addCycle"
                        mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('cycle')"
                        >Add Cycle</button>
                </div>
                
        </div>
        <div class="cycles-container" readOnly>      
        <mat-card class="cycle" *ngFor="let cycle of filteredCycles">
                <mat-card-header>
                        <mat-card-title>
                                <div class="row">
                                        <div class="title">{{cycle.zoneName.name | uppercase}} - {{cycle.strainName | uppercase}}</div>
                                        <div class="title">
                                                <button *ngIf="cycle.currentState.state !== 'End'" mat-button mat-icon-button onclick="this.blur()" (click)="editCycle(cycle)">
                                                        <mat-icon>edit</mat-icon>
                                                </button>
                                                <button *ngIf="cycle.currentState.state !== 'End'" mat-button mat-icon-button onclick="this.blur()" (click)="endCycle(cycle)">
                                                        <mat-icon>stop</mat-icon>
                                                </button>
                                                <button mat-button mat-icon-button onclick="this.blur()" (click)="deleteCycle(cycle)">
                                                        <mat-icon>delete</mat-icon>
                                                </button>
                                        </div>   
                                </div>    
                        </mat-card-title>
                        <mat-card-subtitle>
                                <div class="cycle-status" *ngIf="cycle">
                                        <div class="flex items-center">
                                            <div class="indicator" [ngClass]="!cycle.dates.end ? 'online' : 'offline'"></div>
                                            Cycle status: {{cycle.currentState.state}}
                                        </div>
                                    </div>
                                    <ng-template #notAvailable>
                                        Cycle status: not available 
                                    </ng-template>
                                    <div class="cycle-id" *ngIf="cycle.stateHistory[0]">
                                        Start cycle: {{cycle.dates.start}}
                                    </div>
                                    <div class="cycle-id" *ngIf="cycle.dates.end">
                                        End cycle: {{cycle.dates.end}}
                                    </div>
                                    <div class="day-week-count" *ngIf="cycle.currentState.state !== 'End'">
                                        <span>Current state: {{cycle.currentState.state}} | </span> <b>Week {{cycle.dates.growCycleCountWeek}} Day
                                            {{cycle.dates.growCycleCountDay}}</b>
                                        <hr>
                                    </div>
                                    <div class="CycleTimeNotification">
                                        <mat-slide-toggle [(ngModel)]="cycle.currentState.state" color="primary">Cycle Time Notification</mat-slide-toggle>
                                    </div>
                        </mat-card-subtitle>
                </mat-card-header>
        </mat-card>
</div>

